import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "relative-position" }
const _hoisted_3 = ["href", "data-content-piece", "onClick"]
const _hoisted_4 = { class: "absolute-bottom text-xsmall c-caption text-bold" }
const _hoisted_5 = { class: "ellipsis-2-lines" }

import {onMounted, PropType, ref, watch} from 'vue';
import {openExternalLink} from 'src/etc/utils';
import MarketApi from 'src/api/market';
import CustomSwiperContainer from 'src/apps/core/components/CustomSwiperContainer.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketDetailCrossSellingProducts',
  props: {
  item: Object as PropType<any>
},
  setup(__props) {

const props = __props

const swiperRef = ref<HTMLElement | any | null>(null)
const products = ref<Array<any>>([])

function fetchProducts() {
  MarketApi.getMarketProducts(props.item.uuid)
    .then((resp) => {
      products.value = resp.data
    })
    .catch((err) => {
      console.error(err)
    })
}

onMounted(() => {
  fetchProducts()
})


watch(
  () => swiperRef.value,
  () => {
    if (swiperRef.value?.swiperEle.swiper) {
      Object.assign(swiperRef.value.swiperEle, {
        spaceBetween: 16,
        slidesPerView: 2.3,
        grabCursor: true,
        breakpoints: {
          0: {
            slidesPerView: 2.3,
          },
          1024: {
            slidesPerView: 3.3,
          },
        },
      })
      swiperRef.value.swiperEle.initialize();
    }
  },
  {once: true}
)

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _directive_track_content = _resolveDirective("track-content")!

  return (products.value?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-h3 q-mb-md" }, [
          _createTextVNode("Ähnliche Artikel "),
          _createElementVNode("small", { class: "text-muted text-caption" }, "Werbung")
        ], -1)),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CustomSwiperContainer, {
            ref_key: "swiperRef",
            ref: swiperRef,
            navigation: _ctx.$q.screen.gt.sm
          }, {
            slides: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                return (_openBlock(), _createElementBlock("swiper-slide", {
                  key: product.id
                }, [
                  _createElementVNode("a", {
                    rel: "external nofollow noopener",
                    href: product.url,
                    "data-content-piece": product.title,
                    target: "_blank",
                    onClick: _withModifiers(($event: any) => (_unref(openExternalLink)(product.url)), ["prevent"])
                  }, [
                    _createVNode(_component_q_img, {
                      alt: product.title,
                      loading: "lazy",
                      "no-spinner": "",
                      width: "100%",
                      ratio: 1,
                      src: product.cover_image?.path,
                      class: "rounded-borders bg-grey-2",
                      fit: "cover",
                      fetchpriority: "low"
                    }, {
                      default: _withCtx(() => [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "c-img-overlay absolute-full" }, null, -1)),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(product.title), 1)
                        ])
                      ]),
                      _: 2,
                      __: [0]
                    }, 1032, ["alt", "src"])
                  ], 8, _hoisted_3)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["navigation"])
        ])), [
          [_directive_track_content, {
        name: 'MarketDetailCrossSelling'
      }]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})